import siteJSON from "../data/siteData.json";

const initialState = siteJSON.Data.sort((a, b) => {
  return new Date(b.CreateDate) - new Date(a.CreateDate);
}).map(x => {
  return { ...x, WpData: JSON.parse(x.WpData) };
});

const siteData = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default siteData;
